import { MappingStorage } from "../common/mapper/MappingStorage";
import InkStorage from "../common/penstorage/InkStorage";
import { makeNPageIdStr } from "../common/util/functions";
/**
 * Overlay Page view는 임시로, dummy PDF를 만들어서 대응하고 있다.
 * 화면에 들어오는 width, height가 그대로 pdf width, height로 생각한다.
 *
 * 오버레이의 매체 사이즈를 변경하려면, 매핑 스토리지를 뒤져서, 해당하는 sobp 모두에 size를 변경해야 한다.
 * 2021/09/21
 *
 * @param size_pu
 * @returns
 */
export function prepareNewOverlayPage(size_pu) {
    const msi = MappingStorage.getInstance();
    const theBase = msi.makeTemporaryAssociateMapItem({
        n_paper: undefined,
        pdf: undefined,
        numBlankPages: 1,
        background_image_url_rule: null,
        size_pu
    });
    const pageInfo = theBase.basePageInfo;
    const is = InkStorage.getInstance();
    is.addDummyPage(pageInfo);
    console.log(`Overlay View appended page = ${makeNPageIdStr(pageInfo)}`);
    return pageInfo;
}
//# sourceMappingURL=OverlayPageManager.js.map